(function () {

  angular.module('RegexProvider', [])

    .factory('RegexModel', function () {
      return function () {
        const RegexModel = {};

        RegexModel.pathRegex = function () {
          return /^\/[a-zA-Z0-9]*([a-zA-Z0-9]\/[a-zA-Z0-9][a-zA-Z0-9]*)*$/;
        };

        RegexModel.domainRegex = function () {
          return /^[a-zA-Z0-9/-]*([a-zA-Z0-9/-]\.[a-zA-Z0-9][a-zA-Z0-9]*)*$/;
        };

        RegexModel.domainRegex_v2 = function () {
          return /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        };

        RegexModel.domainRegex_v3 = function () {
          return  /^([a-zA-Z0-9-]+\.){1,}[a-zA-Z]{2,}$/;
        };

        RegexModel.domainSuffix = function () {
          return  /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
        };

        RegexModel.portRegex = function () {
          return  /^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/;
        };

        RegexModel.emailRegex = function () {
          return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        };

        RegexModel.emailRegexParams = function () {
          return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$|\{user_email}/;
        };

        RegexModel.splitEmailString = function () {
          return /[^A-Za-z0-9\p{L}\p{N}_@.!#$%&'*+=?^`{|}~\-/]/gui;
        };

        RegexModel.ipRegex = function () {
          return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i;
        };

        RegexModel.macRegex = function () {
          return /\b((([0-9A-Fa-f]{2}:{1,17}){5}([0-9a-fA-F]{2}))|(([0-9A-Fa-f]{2}){5}([0-9a-fA-F]{2})))\b/i;
        };

        RegexModel.hasNumber = function () {
          return /(?=.*\d)/;
        };

        RegexModel.hasMixedCases = function () {
          return /(?=.*[a-z])(?=.*[A-Z])/;
        };

        RegexModel.passwordValid = function () {
          return /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=^.{6,}$)/;
        };

        RegexModel.splitFileName = function () {
          return /[^A-Z0-9_\p{L}\p{N}]/giu;
        };

        RegexModel.isolateShorthand = function () {
          return /\{.+?\}/g;
        };

        RegexModel.captureThisOrThat = function (param1, param2) {
          return /(?=({user_email},))|({user_email})/g;
        };

        RegexModel.illegalChars = function () {
          return /([/:*?"<>])/g;
        };

        RegexModel.illegalChars_v2 = function () {
          return {
            regex: /([/:*?"<>])/g,
            string: '/ : * ? " < >'
          };
        };

        RegexModel.illegalChars_v3 = function () {
          return {
            regex: /([/:*?"<>])/g,
            string: '/ : * ? " < >'
          };
        };

        RegexModel.illegalChars_not_global = function () {
          return {
            regex: /([/:*?"<>])/,
            string: '/ : * ? " < >'
          };
        };

        RegexModel.illegalCharsCheck = function () {
          return /^[^/:*?"<>]*$/;
        };

        RegexModel.badNameString = function () {
          return {
            regex: /([~"#%&*:<>?/\\{|}.])/g,
            regex2: /^[^~"#%&*:<>?/\\{|}.]*$/,
            string: '~ " # % & * : < > ? / \\ { | } .'
          };
        };

        RegexModel.badNameString_variables = function () {
          return {
            regex: /([~"#%&*:<>?/\\|.])/g,
            string: '~ " # % & * : < > ? / \\ | .'
          };
        };

        RegexModel.badEmailString_variables = function () {
          return {
            regex: /([~"#%&*:<>?/\\|])/g,
            string: '~ " # % & * : < > ? / \\ |'
          };
        };

        RegexModel.badPathString_variables = function () {
          return {
            regex: /[~"#%&*:<>?\\|.]/g,
            string: '~ " # % & * : < > ? \\ | .'
          };
        };

        RegexModel.badAddressHostname = function () {
          return {
            regex: /([~"#%&*<>?/\\{|}])/g,
            string: '~ " # % & * < > ? / \\ { | } '
          };
        };

        RegexModel.urlRegex = function () {
          return new RegExp(
            '^(https?:\\/\\/)' +                                  // protocol (only 'http' or 'https' will be accepted)
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +  // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' +                       // OR IP (v4) address
            '(\\:\\d{2,5})?' +                                    // port
            '(\\/[-a-z\\d%_.~+]*)*' +                             // path
            '(\\?[;&a-z\\d%_.~+=-]*)?' +                          // query string
            '(\\#[-a-z\\d_]*)?$',                                 // fragment locator
            'i'                                                   // ignore casing differences
          );
        };

        return RegexModel;
      };
    });

})();
